<div class="event-data">
  <div class="post-text-wrapper" [class.post-text-wrapper--secondary]="variant() === 'secondary'">
    @if (requiresPurchase) {
      <div class="disabled-layer">
        <button class="community-button subscribe" (click)="onSubscribeClick($event)">
          <outlaw-icon class="icon-svg" name="ticket" />
          Subscribe to watch
        </button>
      </div>
    }

    @if (item().content.images?.length) {
      <app-slider
        [images]="mappedImages()"
        [class.mobile-slider]="variant() === 'primary'"
        [openInSameWindow]="openInSameWindow()"
        (navigateToPost)="onPostClick()"
      />
    }
    <div class="date">{{ item().created_at | unixDateFormatter }}</div>

    <app-text-content
      [title]="item().content.title"
      [text]="item().content.text"
      [postUrl]="postUrl()"
      [openInSameWindow]="openInSameWindow()"
      (postClick)="onPostClick()"
    />
  </div>

  @if (showShowFiles()) {
    <div class="files-container">
      @for (file of item().content.files; track file.file_id) {
        <ol-file-item [file]="file" [hasAccess]="postAccess" />
      }
    </div>
  }

  <ng-content>
    @if (!requiresPurchase && item().content.links?.length) {
      <div class="links-container" [class.links-container--secondary]="variant() === 'secondary'">
        @for (link of item().content.links; track link; let index = $index) {
          <a
            [olExternalLink]="link.link_url"
            [target]="linkTarget()"
            [isMajiApp]="isMajiApp()"
            class="watch-film community-button primary"
            [dataTest]="'post-link-' + index"
          >
            {{ link.link_text }}
          </a>
        }
      </div>
    }
  </ng-content>
</div>
